import styled from 'styled-components'

interface IPropsLoadingContainer {
  opacity: 0 | 1;
}

export const Container = styled.div`
  background: ${props => props.theme.colors.silverBG};
  display: grid;
  grid-template-columns: auto 65% auto;
  align-items: center;
  /* width: max-contents ;  */

  @media (max-width: 700px) {
    grid-template-columns: auto 80% auto;
  }
`

export const FeedContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`


export const Overlay = styled.div`
  width: 100%;
  padding: 10px;
`

export const LoadingContainer = styled.div<IPropsLoadingContainer>`
  width: 100%; 
  display: flex; 
  align-items: center; 
  justify-content: center;
  opacity: ${props => props.opacity};
 `



